import React from "react";
import { SealCheckIcon as SealCheck, CrownIcon as Crown } from "@phosphor-icons/react";

/**
 * Elite Verified Breeder badge ($199/yr prestige tier) and the
 * companion one-time Verified Kennel badge ($79).
 *
 * Use VerifiedBadge for Pro/Elite plan tiers (subscription-based).
 * Use EliteBadge for the dedicated prestige verification system.
 */
export default function EliteBadge({
  elite = false,
  verified = false,
  size = "sm",
  showLabel = true,
  className = "",
}) {
  const px = size === "lg" ? 18 : size === "md" ? 14 : 12;
  if (elite) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em] bg-gradient-to-r from-[#C9A227] to-[#E8C75E] text-[#0E0E0E] border border-[#C9A227]/40 ${className}`}
        data-testid="badge-elite-verified"
        title="Elite Verified Breeder — annual prestige tier"
      >
        <Crown size={px} weight="fill" />
        {showLabel && "Elite Verified"}
      </span>
    );
  }
  if (verified) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em] bg-[#0E0E0E] text-[#C9A227] border border-[#C9A227]/40 ${className}`}
        data-testid="badge-kennel-verified"
        title="Verified Kennel — identity confirmed"
      >
        <SealCheck size={px} weight="fill" />
        {showLabel && "Verified"}
      </span>
    );
  }
  return null;
}
